// extracted by mini-css-extract-plugin
export default {"wrapper":"example-card_wrapper__G0NTM","container":"example-card_container__Cs5W3","boxTitle":"example-card_boxTitle__IbzEn","boxImage":"example-card_boxImage__qXEHB"};